import type { FunctionSignature } from './decorators.types';

/**
 * Creates default tags with auto-derived values
 */
export function createDefaultTags(
  className: string,
  methodName: string,
  packageName?: string,
  customTags?: Record<string, string | number | boolean>
): Record<string, string | number | boolean> {
  const defaultTags = {
    service: className,
    operation: methodName,
    package: packageName || 'desygner-nx',
  };

  return { ...defaultTags, ...customTags };
}

export function stringifyParameters(parameters: unknown[]): string {
  return parameters
    .map((param) => {
      if (typeof param === 'object') {
        // If param is an object, stringify and unescape quotes for readability
        return JSON.stringify(param).replace(/\\"/g, '');
      }

      return String(param);
    })
    .join(', ');
}
/**
 * Creates an enhanced error with function signature information
 */
export function createEnhancedError(
  originalError: Error,
  functionSignature: FunctionSignature,
  customMessage?: string
): Error {
  const signature = `${functionSignature.className}.${functionSignature.methodName}(${functionSignature.parameters})`;

  const enhancedMessage = customMessage || `Error in ${signature}: ${originalError.message}`;

  const enhancedError = new Error(enhancedMessage);

  enhancedError.name = originalError.name;
  enhancedError.stack = originalError.stack;

  // Copy additional properties from original error
  Object.keys(originalError).forEach((key) => {
    if (!(key in enhancedError)) {
      (enhancedError as unknown as Record<string, unknown>)[key] = (
        originalError as unknown as Record<string, unknown>
      )[key];
    }
  });

  // Add function signature to error object
  (enhancedError as unknown as Record<string, unknown>)['functionSignature'] = functionSignature;

  return enhancedError;
}
